import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import CardDialog from '@/components/dialogs/CardDialog.vue'
import { useSlots } from 'vue'
import { useI18n } from 'vue-i18n'

interface Props {
  /** Title of the confirm dialog */
  title?: string | null
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'ConfirmDialog'
},
  __name: 'ConfirmDialog',
  props: {
    title: { default: null }
  },
  setup(__props: any) {





const { t } = useI18n()
const slots = useSlots()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CardDialog, {
    title: __props.title ?? _unref(t)('general.confirm')
  }, _createSlots({
    action: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('general.confirm')), 1)
    ]),
    _: 2
  }, [
    _renderList(Object.keys(_unref(slots)), (slot, index) => {
      return {
        name: slot,
        fn: _withCtx(() => [
          _renderSlot(_ctx.$slots, slot)
        ])
      }
    })
  ]), 1032, ["title"]))
}
}

})